import errorMsg from '../../../constants/errormsg';

const StringUtil = {
  isEmptyString: target => {
    // 対象が空文字かスペース、タブ、改ページ、改行を含むホワイトスペース文字かを判定します。
    return !target || !target.match(/\S/g);
  },
  createSystemErrorMsg: message => {
    return errorMsg.SYSTEM_ERROR_TEMPLATE.replace(errorMsg.ERROR_MSG_REPLACE, message);
  },
  createFilename: (filename, extention) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const hours = ('0' + now.getHours()).slice(-2);
    const minutes = ('0' + now.getMinutes()).slice(-2);
    return filename + year + month + day + '_' + hours + minutes + extention;
  }
};

export default StringUtil;



// WEBPACK FOOTER //
// ./src/functions/utils/string/index.js